import React, { Component } from "react";
import PropTypes from "prop-types";
import classNames from "classnames";

import { withStyles } from "@material-ui/core/styles";

const styles = {
  placeholder: {
    backgroundColor: "#f6f6f6",
    backgroundSize: "cover",
    backgroundRepeat: "no-repeat",
    position: "relative",
    overflow: "hidden",
    "& img": {
      position: "absolute",
      opacity: 0,
      top: "0px",
      left: "0px",
      width: "100%",
      height: "100%",
      transition: "opacity 1s linear"
    },
    "& $loaded": {
      opacity: 1
    },
    "& $imageLargeLoaded": {
      opacity: 0
    }
  },
  loaded: {},
  imageLargeLoaded: {},
  imgSmall: {
    filter: "blur(30px)"
    /* this is needed so Safari keeps sharp edges */
    // transform: "scale(1)"
  }
};

class ProgressiveImage extends Component {
  state = {
    imgSmallLoaded: false,
    imgLargeLoaded: false
  };
  onImgSmallLoaded = () => {
    this.setState({ imgSmallLoaded: true });
  };
  onImgLargeLoaded = () => {
    this.setState({ imgLargeLoaded: true });
    this.props.onLoad && this.props.onLoad();
  };
  render() {
    const {
      classes,
      className,
      imgSmall,
      imgLarge,
      alt,
      objectFit = "cover",
      objectPosition = "initial",
      paddingBottom,
      backgroundColor
    } = this.props;
    return (
      <div
        className={classNames(classes.placeholder, className)}
        style={{ backgroundColor }}
        title={alt}
      >
        {imgSmall && (
          <img
            src={imgSmall}
            className={classNames(classes.imgSmall, {
              [classes.loaded]: this.state.imgSmallLoaded,
              [classes.imageLargeLoaded]: this.state.imgLargeLoaded
            })}
            style={{ objectFit, objectPosition }}
            onLoad={this.onImgSmallLoaded}
            alt={alt}
          />
        )}
        <img
          src={imgLarge}
          className={classNames({
            [classes.loaded]: this.state.imgLargeLoaded
          })}
          style={{ objectFit, objectPosition }}
          onLoad={this.onImgLargeLoaded}
          alt={alt}
        />
        <div style={{ paddingBottom }} />
      </div>
    );
  }
}
ProgressiveImage.propTypes = {
  classes: PropTypes.object.isRequired,
  imgSmall: PropTypes.string,
  imgLarge: PropTypes.string.isRequired,
  alt: PropTypes.string.isRequired,
  backgroundColor: PropTypes.string,
  onLoad: PropTypes.func,
  paddingBottom: PropTypes.string.isRequired
};

export default withStyles(styles)(ProgressiveImage);



// WEBPACK FOOTER //
// ./src/components/Image/ProgressiveImage.js